<template>
  <div class="page-content conmon-top field-manage">
    <el-tabs class="setting-tabs" v-model="activeName" @tab-click="handleClick">
      <!-- <el-tab-pane label="关注人数" name="first">
        <field-total></field-total>
      </el-tab-pane> -->
      <el-tab-pane label="参与人数" name="second">
        <participants-number></participants-number>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
// import {  } from '@/api/customer.js'
import { API_HOST } from '@/api/local'
import participantsNumber from '@/components/offline-acivity/participants-number'
export default {
  name: 'activityStatistics',
  data () {
    return {
      activeName: 'second'
    }
  },
  mounted () {
  },
  methods: {
    handleClick(tab, event) {
    }
  },
  created() {
  },
  components: {
    participantsNumber
  }
}
</script>

<style scoped>
.structure .el-select {
  width: 300px;
}
</style>
